<template>
  <div>

    <!-- 顶部显示的页面 -->
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin-bottom:10px"
    >
      <el-breadcrumb-item>套餐</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 新增套餐的按钮 -->
    <div>
      <el-button
        type="primary"
        @click="NewlyAdded"
      >新增</el-button>
    </div>
    <!-- 套餐列表 -->
    <div style="margin-top:20px">
      <el-table
        :data="tableList"
        style="width: 100%"
        @row-click="rowclick"
      >
        <el-table-column
          label="套餐名称"
          prop="packageName"
        >
        </el-table-column>
        <el-table-column
          label="景区数量"
          prop="count"
        >
        </el-table-column>
        <el-table-column
          label="原价格"
          prop="originPrice"
        >
        </el-table-column>
        <el-table-column label="套餐价格">
          <template slot-scope="scope">
            <p v-if="scope.row.price">{{scope.row.price}}</p>
            <p v-else>0</p>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="edit(scope.$index, scope.row)"
            >修改套餐</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >删除套餐</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 弹框 -->
    <el-dialog
      title="修改套餐价格"
      :visible.sync="editDialogVisible"
      width="50%"
      center
    >
      <el-input
        v-model="packageName"
        placeholder="请输入内容"
      ></el-input>
      <div style="margin: 10px 0;">
        <el-button
            type="primary"
            @click="packageLineAdd"
        >添加</el-button>
      </div>
      <el-table
        :data="bulletList"
        style="width: 100%"
      >
        <el-table-column label="景区名称">
          <template slot-scope="scope">
            <el-select v-model="scope.row.area_id" filterable @change="scenicSelect(scope.$index, scope.row)">
                <el-option
                v-for="item in scenicAll"
                :key="'scenic' + item.area_id"
                :label="item.area_name"
                :value="item.area_id"/>
            </el-select>
          </template>
        </el-table-column>

        <el-table-column
          label="语音价格"
          prop="original_price"
        >
        </el-table-column>
        <el-table-column label="套餐价格">
          <template slot-scope="scope">
            <!-- <span>{{scope.row.area_ticket}}</span> -->
            <el-input
              placeholder="请输入套餐价格"
              type="number"
              v-model="packagePriceNumber[scope.$index]"
              @change="changePackagePrice"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDeletePackageLine(scope.$index)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="Preservation"
        >保 存</el-button>
      </span>
    </el-dialog>

    <!-- 分页 -->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total,  prev, pager, next, jumper"
        :total="total"
        style="text-align:right;margin:0 16px 10px 0;border-radius:20px"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  props: {
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      tableData: [],
      scenicAll: [],
      input: '',
      currentPage: 1,   //分页
      total: 0,        //分页
      tableList: [],
      editDialogVisible: false,   //商品编辑的弹框
      editInfo: [],               //商品编辑的数据集合
      input1: '',               //景区名称
      input2: '',               //景区原价格
      input3: '',                //景区套餐价格
      packagePriceNumber: [],     //套餐价格输入框
      bulletList: [],              //弹框的表格
      packageId: 0,
      packageName: ''
    }
  },
  methods: {
    // 新增按钮的方法
    NewlyAdded () {
      this.$router.push({
        path: "/SetMealList",
        query: {
          // staff_id: row.staff_id,
          // channelid: that.$route.query.channelid,
          // user_id: row.user_id
        }
      });
    },
    // 设置套餐价格
    changePackagePrice (value) {
      // console.log('========================')
      // console.log(value)
      // var packagenumber = 0
      // this.packageTotalPrice = 0
      // for (var i = 0; i < this.packagePriceNumber.length; i++) {
      //   if (this.packagePriceNumber[i]) {
      //     this.packageTotalPrice = this.packageTotalPrice + parseFloat(this.packagePriceNumber[i])
      //   }
      // }
    },
    // 套餐查询
    findScenicSpot () {
      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;
      var packageList = []
      var salesInfoData = {
        count: true,
        // area_id: that.areaID,
        // orderby: "area_id desc",
        pageindex: this.currentPage,
        pagesize: 10
      };
      var salesInfoParams = {
        methodUrl: "/admin/getPackageInfo",
        jsonParam: qs.stringify(salesInfoData)
      };
      this.$axios.postRequest(salesInfoParams).then(
        function (res) {
          //成功之后处理逻辑
          that.tableData = res.data.list;
          that.total = res.data.totalcount;
          that.tableList = []
          for (var i = 0; i < res.data.list.length; i++) {
            var info = {}
            var price = 0
            var originPrice = 0
            var count = 0
            res.data.list[i].package_info.forEach(item => {
              count++
              price = parseFloat((price + parseFloat(item.area_price)).toFixed(2))
              originPrice = parseFloat((originPrice + parseFloat(item.original_price)).toFixed(2))
            });
            info.packageId = res.data.list[i].package_id
            info.price = price
            info.originPrice = originPrice;
            info.count = count;
            info.packageName = res.data.list[i].package_name
            info.package_info = res.data.list[i].package_info
            that.tableList.push(info)
          }
        },
        function (res) {
          //失败之后处理逻辑
          console.log("error:");
        }
      );
    },
    getAllScenic(){
      this.$axios.postRequest({
        methodUrl: "admin/getScenicArea",
        jsonParam: qs.stringify({
            pageindex: 1,
            pagesize: 1000,
        })
      }).then(
        res => {
          //成功之后处理逻辑
          this.scenicAll = res.data.list
        },
      )
    },
    // 用户编辑
    edit (index, row) {
      console.log('======================123132102============')
      // this.singleClick = true
      this.editDialogVisible = true
      console.log(row.packageName, 112)
      this.bulletList = row.package_info
      this.packageId = row.packageId
      this.packageName = row.packageName
      this.packagePriceNumber = []
      row.package_info.forEach(element => {
        if (element.area_price) {
          this.packagePriceNumber.push(element.area_price)
        } else {
          this.packagePriceNumber.push(0)
        }
      });
    },
    packageLineAdd(){
        this.bulletList.push({
            original_price: '',
        })
    },
    scenicSelect(index, row){
        this.$axios.postRequest({
            methodUrl: "admin/getScenicArea",
            jsonParam: qs.stringify({
                area_id: row.area_id,
            }),
        }).then(
            res => {
                const list = res.data.list
                if(list && list.length > 0){
                    this.bulletList[index].original_price = list[0].voice_price
                }
            },
        )
    },
    handleDeletePackageLine(index){
        this.bulletList.splice(index, 1)
    },
    Preservation () {
      this.editDialogVisible = false
      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;
      var area_ids = []
      var prices = []
      this.bulletList.forEach(item => {
        area_ids.push(item.area_id)
      });
      var areaID = area_ids.join(",")
      var originaiPrices = this.packagePriceNumber.join(",")
      var salesInfoData = {
        do_lx: 2,
        package_id: this.packageId,
        area_id: areaID,
        area_price: originaiPrices,
        package_name: this.packageName
      };
      var salesInfoParams = {
        methodUrl: "/admin/addPackageInfo",
        jsonParam: qs.stringify(salesInfoData)
      };
      this.$axios.postRequest(salesInfoParams).then(
        function (res) {

          if (res.code == 0) {
            that.findScenicSpot()
            that.dialogVisible = false
          }
          else {
            that.$message.error(res.msg);
          }
        },
        function (res) {
          //失败之后处理逻辑
          console.log(res);
          that.$message.error('网络错误')
        }
      );
    },
    // // 删除套餐
    handleDelete (index, row) {
      console.log('++++++++++++++++')
      console.log(row)
      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;
      var salesInfoData = {
        do_lx: 3,
        package_name: row.packageName,
        package_id: row.packageId,
      };
      var salesInfoParams = {
        methodUrl: "/admin/addPackageInfo",
        jsonParam: qs.stringify(salesInfoData)
      };
      this.$axios.postRequest(salesInfoParams).then(
        function (res) {
          //成功之后处理逻辑
          if (res.code == 0) {
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            that.findScenicSpot()
          } else {
            that.$message.error(res.errMsg);
          }
          // that.tableData = res.data.list;
          // that.total = res.data.totalcount;
        },
        function (res) {
          //失败之后处理逻辑
          console.log("error:");
        }
      );
    },
    // 点击行
    rowclick (row, column, event) {
      // console.log(row)
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val;
      this.findScenicSpot();
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this.findScenicSpot();
    },

    // 表格
    // handleEdit (index, row) {
    //   console.log(index, row);
    // },
    // handleDelete (index, row) {
    //   console.log(index, row);
    // }
    ViewDetails (index, row) {
    }
  },
  mounted () {
    this.findScenicSpot()
    this.getAllScenic()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SetMeal.vue